import React, { lazy, Suspense, memo } from 'react'
import { Box } from '@mui/material'
import Header from '../Header'

const Footer = lazy(() => import('../Footer'))

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        overflowX: 'hidden',
        width: '100%'
      }}>
      <Header />
      <Box
        component="main"
        sx={{
          paddingTop: { xs: '64px', sm: '70px' },
          paddingBottom: { xs: 3, md: 5 },
          px: { xs: 2, sm: 3, md: 4 },
          width: '100%',
          maxWidth: '100%',
          flexGrow: 1,
          boxSizing: 'border-box'
        }}>
        {children}
      </Box>
      <Suspense
        fallback={
          <Box aria-hidden sx={{ width: '100%', minHeight: 220 }} />
        }>
        <Footer />
      </Suspense>
    </Box>
  )
}

export default memo(Layout)
